import React, { useRef, useState, useEffect } from 'react'
import Slider from "react-slick";
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from "react-icons/bs";
import axios from 'axios'

import TopperCard from './TopperCard/TopperCard'

import './Toppers.css'
import { useScreenWidth } from '../../../hooks/useScreenWidth';

const TOPPERS_URL = "/toppers"


function Toppers() {

    const sliderRef = useRef();
    const [toppers, setToppers] = useState('')
    const [width] = useScreenWidth()

    useEffect(() => {
      async function getToppers() {
        try {
          const response = await axios.get(process.env.REACT_APP_DEPT_API + TOPPERS_URL);
          setToppers(response.data);
        } catch (error) {
          console.error(error);
        }
      }
      getToppers()
    }, [])

    const sortedToppers = toppers && toppers.sort((a, b) => a.semester > b.semester ? -1 : 1)

    const setNumberOfSlides = () => {
        if(width > 1300) 
            return 4
        else if(width > 1100 && width < 1300) 
            return 3
        else if(width > 600 && width < 1100) 
            return 2
        else if(width < 600) 
            return 1
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: setNumberOfSlides(),
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        fade: false,
        pauseOnHover: false
    };

    const gotoNext = () => {
        sliderRef.current.slickNext();
    }

    const gotoPrev = () => {
        sliderRef.current.slickPrev();
    }

    return (
        <div className='toppers'>
            <div className='section__container'>
                <div className='section'>
                    <h1 className='section__header '>Current Toppers</h1>
                    <div className='toppers__container'>
                        <BsFillArrowLeftCircleFill onClick={gotoPrev} className='topper_arrow_left'/>
                        <div className='toppers_slider'>
                            <Slider {...settings}  ref={sliderRef}>
                                {sortedToppers && sortedToppers.map((tpr) => (
                                    <TopperCard 
                                        key={tpr._id}
                                        name={tpr.name}
                                        photo={tpr.image.url}
                                        semester={tpr.semester}
                                        result={tpr.result}
                                    />
                                ))}
                            </Slider>
                        </div>
                        <BsFillArrowRightCircleFill onClick={gotoNext} className='topper_arrow_right'/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Toppers